import { StoreDomain, StorePageConfig, StorePageId } from "../../data/models/Experience/ExperienceSharedModels";

export type SnackbarSeverity = "success" | "error";

export const experienceToggleGroupSx = {
  p: 0.5,
  width: "100%",
  maxWidth: "100%",
  overflowX: "auto",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1.5,
  bgcolor: "background.paper",
  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "8px !important",
  },
  "& .MuiToggleButton-root": {
    flex: "0 0 auto",
    px: { xs: 1.25, sm: 1.75 },
    minHeight: 38,
    textTransform: "none",
    gap: 0.75,
  },
};

export const experiencePageLabels: Record<StorePageId, string> = {
  home: "Inicio",
  about: "Nosotros",
  contact: "Contáctanos",
  terms: "Términos",
  privacy: "Privacidad",
};

export const mergeExperiencePages = (basePages: StorePageConfig[], pages?: StorePageConfig[]) =>
  basePages.map((page) => ({ ...page, ...(pages || []).find((item) => item.id === page.id) }));

export const domainStatusColor = (status: StoreDomain["status"]) => {
  if (status === "active") return "success" as const;
  if (status === "disabled") return "default" as const;
  return "warning" as const;
};
